<template>
  <vue-recaptcha sitekey="6LeBScQZAAAAAMtI0CJ5krbVZe625u3hZIx9PK7Y" @verify="onVerify" :loadRecaptchaScript="true"></vue-recaptcha>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import api from "@/api";

/**************************************************************/
/********http://127.0.0.1:5000/#/Forms/Form/request/***********/
/********site key and secret key can be found on account*******/
/********hanktam@legatosolutions.com***************************/
/********Default password**************************************/
/**************************************************************/

export default {
  name: "reCAPTCHA",
  props: ["isedit"],
  data(){
       return {
            g_recaptcha_response: null
       }
    
  },
  components: { VueRecaptcha },
  mounted() {
    var vm = this;
    console.log(vm);
  },
  computed: {},
  methods: {
    onVerify: function (response) {
      if(response){
        // this.g_recaptcha_response = response;
        // this.$parent.$attrs.g_recaptcha_response = response;
        this.$parent.$parent.g_recaptcha_response = response
        console.log('reached here');
      }
    }
  },
  watch: {}
};
</script>
